// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3biGx","footer":"ReportModalFilter_footer__hxpZK"};